<template>
  <div class="mt-6">
    <v-row
      no-gutters
      align="center"
    >
      <div class="text-h6">Прогноз отправки PUSH уведомлений</div>
      <v-btn
        icon
        class="ml-2"
        @click="$emit('refreshForecast')"
        :loading="loading"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-row>
    <div class="text-subtitle-1 font-weight-medium mb-2">Пользователи</div>
    <div class="ml-2">
      <div class="d-flex align-center mb-2">
        <div class="text-body-1">Получат уведомление:</div>
        <div class="ml-2">{{ forecast.total_pushes }}</div>
        <div class="ml-2 success--text">({{ recipientsPercentage }}%)</div>
      </div>
      <div class="d-flex align-center">
        <div class="text-body-1">Всего пользователей:</div>
        <div class="ml-2">{{ forecast.total_filtered_users }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'PushForecast',
    props: {
      forecast: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean
      }
    },
    emits: ['refreshForecast'],
    computed: {
      recipientsPercentage() {
        if (!this.forecast.total_users || !this.forecast.total_filtered_users) return 0
        const res =
          (this.forecast.total_filtered_users / (this.forecast.total_filtered_users || 1)) * 100
        if (!res) return 0
        let precision = 0
        let stopped = false
        for (const char of String(res).replace('.', '').split('')) {
          if (stopped) return
          if (char !== '0') {
            stopped = true
            break
          }
          precision++
        }
        if (!precision) precision = 2
        return res.toFixed(precision)
      }
    },
    mounted() {
      this.$emit('refreshForecast')
    }
  })
</script>
